import { Cookies } from 'react-cookie';

import { getHubApiResponse } from './../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getHub = async (hubId: number) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/hub_update/${hubId}`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as getHubApiResponse;
};
